<div id="content" class="extensible">
  <div class="page-title">
    <h1>{{ page_title }}</h1>

    @if (length > 0) {
      @if (generatingPayrolls) {
        <button mat-flat-button color="accent" disabled>
          <mat-icon>hourglass_empty</mat-icon>
          Generando nóminas...
        </button>
      } @else if (importing_gestoria_pdf) {
        <button mat-flat-button color="accent" disabled>
          <mat-icon>hourglass_empty</mat-icon>
          Importando PDF…
        </button>
      } @else if (isFormModified) {
        <button mat-stroked-button color="accent" (click)="savePayrolls()">
          <mat-icon>save</mat-icon>
          Guardar cambios
        </button>
      } @else if (!is_send_management_all) {
        <button mat-flat-button color="accent" (click)="sendPayrollsToTheManagement()" [disabled]="isFormModified">
          <mat-icon>send</mat-icon>
          Enviar a gestoría
        </button>
      } @else if (!is_send_employees_all) {
        <button mat-flat-button color="accent" (click)="sendPayrollsToTheEmployee()" [disabled]="isFormModified">
          <mat-icon>send</mat-icon>
          Enviar a empleados
        </button>
      }

      <button
        mat-stroked-button
        color="accent"
        type="button"
        [matMenuTriggerFor]="payrollActionsMenu"
        [disabled]="generatingPayrolls || importing_gestoria_pdf"
      >
        <mat-icon>more_horiz</mat-icon>
        Más acciones
      </button>
      <mat-menu #payrollActionsMenu="matMenu">
        <button mat-menu-item type="button" (click)="generatePayrolls(true)" [disabled]="isFormModified">
          <mat-icon>autorenew</mat-icon>
          <span>Regenerar nóminas</span>
        </button>
        <button mat-menu-item type="button" (click)="pickGestoriaPdf()" [disabled]="isFormModified">
          <mat-icon>picture_as_pdf</mat-icon>
          <span>Importar PDF gestoría</span>
        </button>
        <button mat-menu-item type="button" (click)="openGestoriaReview()">
          <mat-icon>fact_check</mat-icon>
          <span>Revisar importación</span>
        </button>
        <button mat-menu-item type="button" (click)="downloadPayrollsFile()" [disabled]="isFormModified">
          <mat-icon>download</mat-icon>
          <span>Descargar excel</span>
        </button>
      </mat-menu>
      <input #gestoria_pdf_input type="file" accept="application/pdf" hidden (change)="onGestoriaPdfSelected($event)" />
    } @else {
      <button mat-flat-button color="accent" (click)="generatePayrolls(false)" [disabled]="generatingPayrolls">
        <mat-icon>{{ generatingPayrolls ? 'hourglass_empty' : 'refresh' }}</mat-icon>
        {{ generatingPayrolls ? 'Generando nóminas...' : 'Generar nóminas' }}
      </button>
    }
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      >
      </mat-paginator>

      <mat-form-field appearance="outline" id="period-selector">
        <mat-label>Seleccionar periodo</mat-label>

        <button mat-icon-button matPrefix (click)="goPreviousMonth()" matTooltip="Mes anterior">
          <mat-icon>chevron_left</mat-icon>
        </button>

        <mat-date-range-input [rangePicker]="dp">
          <input matStartDate placeholder="Start date" formControlName="working_period_from" />
          <input matEndDate placeholder="End date" formControlName="working_period_to" />
        </mat-date-range-input>
        <mat-hint>DD/MM/YYYY - DD/MM/YYYY</mat-hint>

        <button mat-icon-button matSuffix (click)="goNextMonth()" matTooltip="Siguiente mes">
          <mat-icon>chevron_right</mat-icon>
        </button>

        <mat-date-range-picker #dp></mat-date-range-picker>
      </mat-form-field>

      @if (length > 0) {
        <mat-form-field id="search-ctrl" appearance="outline">
          <input matInput type="text" formControlName="search" placeholder="Busca por nombre de empleado" />
          <button matSuffix mat-icon-button aria-label="Clear">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      }
    </form>

    <div class="bisual-table-container">
      @if (generatingPayrolls) {
        <div class="generating-payrolls-container">
          <mat-icon style="font-size: 64px; width: 64px; height: 64px; margin-bottom: 24px; color: #1976d2">hourglass_empty</mat-icon>
          <h3 style="margin: 0 0 16px 0; font-size: 24px; font-weight: 500; color: #333">Generando nóminas...</h3>
        </div>
      } @else if (
        dataSource != null &&
        dataSource.data.length > 0 &&
        dataSource.data[0].value.user != null &&
        dataSource.data[0].value.user.working_contracts[0] != null
      ) {
        <table mat-table [dataSource]="dataSource" [class.disabled-table]="generatingPayrolls">
          <ng-container matColumnDef="name" sticky>
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let formGroup">
              <img
                class="avatar"
                [src]="formGroup.value.user.profile_picture_url"
                [alt]="formGroup.value.user.name + ' ' + formGroup.value.user.surnames"
              />
              <span style="display: inline-flex; flex-direction: column">
                {{ formGroup.value.user.name + ' ' + formGroup.value.user.surnames }}
                <span class="contract">
                  <!-- Tipo de contrato -->
                  {{ formGroup.value.user.working_contracts[0].working_contract_type.name }}

                  @if (!PER_HOUR_CONTRACTS.includes(formGroup.value.user.working_contracts[0].working_contract_type.slug)) {
                    <!-- Condicions contracte -->
                    /
                    {{
                      formGroup.value.user.working_contracts[0].working_contract_variable_conditions[0].hours_per_week_expected
                        | number: '1.0-0'
                    }}h/set
                  }

                  <br />

                  {{ formGroup.controls['payroll_file'].value?.name }}
                </span>
              </span>
            </td>
          </ng-container>

          <!-- Contract -->
          <ng-container matColumnDef="working_contract_type">
            <th mat-header-cell *matHeaderCellDef>Tipo de contrato</th>
            <td mat-cell *matCellDef="let formGroup">{{ formGroup.value.user.working_contracts[0].working_contract_type.name }}</td>
          </ng-container>

          <ng-container matColumnDef="hours_per_week_expected">
            <th mat-header-cell *matHeaderCellDef>Jornada</th>
            <td mat-cell *matCellDef="let formGroup">
              @if (!PER_HOUR_CONTRACTS.includes(formGroup.value.user.working_contracts[0].working_contract_type.slug)) {
                {{
                  formGroup.value.user.working_contracts[0].working_contract_variable_conditions[0].hours_per_week_expected
                    | number: '1.0-0'
                }}h
              } @else {
                -
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="number_of_payments_per_year">
            <th mat-header-cell *matHeaderCellDef>N. Pagas</th>
            <td mat-cell *matCellDef="let formGroup">
              @if (!PER_HOUR_CONTRACTS.includes(formGroup.value.user.working_contracts[0].working_contract_type.slug)) {
                {{ formGroup.value.user.working_contracts[0].number_of_payments_per_year | number: '1.0-0' }}
              } @else {
                -
              }
            </td>
          </ng-container>

          <!-- Money -->
          <ng-container matColumnDef="sa">
            <th mat-header-cell *matHeaderCellDef matTooltip="Salario bruto anual. Incluye Seniority.">SA Bisual</th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              @if (!PER_HOUR_CONTRACTS.includes(formGroup.value.user.working_contracts[0].working_contract_type.slug)) {
                <span
                  [matTooltip]="
                    (formGroup.value.brute_base_anual_salary | currency) + ' + ' + (formGroup.value.seniority_bonus_anual | currency)
                  "
                >
                  {{ formGroup.value.brute_base_anual_salary + formGroup.value.seniority_bonus_anual | currency }}
                </span>
              } @else {
                -
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="sm_theorical">
            <th
              mat-header-cell
              *matHeaderCellDef
              matTooltip="Salario bruto mensual. Incluye Seniority y Pluses de Bisual. El de la tabla salarial."
            >
              SM Teórico
            </th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              @if (!PER_HOUR_CONTRACTS.includes(formGroup.value.user.working_contracts[0].working_contract_type.slug)) {
                <span>
                  @if (formGroup.value.user.working_contracts[0].number_of_payments_per_year) {
                    {{
                      (formGroup.value.brute_base_anual_salary + formGroup.value.seniority_bonus_anual) /
                        formGroup.value.user.working_contracts[0].number_of_payments_per_year | currency
                    }}
                  }
                </span>
              } @else {
                -
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="sm_practical">
            <th
              mat-header-cell
              *matHeaderCellDef
              matTooltip="Salario bruto mensual. Incluye Seniority y Pluses de Bisual. Se incluyen pluses según rendimiento real."
            >
              SM Calculado
            </th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              @if (!PER_HOUR_CONTRACTS.includes(formGroup.value.user.working_contracts[0].working_contract_type.slug)) {
                <span [matTooltip]="buildSmCalculatedTooltip(formGroup)">
                  {{
                    formGroup.value.brute_base_salary +
                      formGroup.value.seniority_bonus +
                      formGroup.value.plus_0_amount +
                      formGroup.value.plus_1_amount +
                      formGroup.value.plus_2_amount | currency
                  }}
                </span>
              } @else {
                <span
                  [matTooltip]="
                    (formGroup.value.hours_worked_since_last_day_taken_into_account_for_hours | number: '1.2-2') +
                    'h * ' +
                    formGroup.value.price_per_hour +
                    '€/h'
                  "
                >
                  {{ formGroup.value.brute_base_salary | currency }}
                </span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="payroll_adjustments">
            <th mat-header-cell *matHeaderCellDef matTooltip="Resumen de ajustes de la nómina. Clic para ver el detalle.">Ajustes</th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              @let chips = getPayrollAdjustmentChips(formGroup);
              @if (chips.length) {
                <button
                  type="button"
                  class="payroll-adjustments-btn"
                  matTooltip="Ver justificación de la nómina"
                  (click)="openPayrollJustificationDialog(i)"
                >
                  @for (chip of chips; track chip.key) {
                    <span
                      class="payroll-adjustment-chip"
                      [class.is-positive]="chip.amount != null && chip.amount > 0 && !chip.is_expected_normal"
                      [class.is-negative]="chip.amount != null && chip.amount < 0 && !chip.is_kpi_cut"
                      [class.is-neutral]="chip.amount == null || chip.amount === 0 || chip.is_expected_normal"
                      [class.is-kpi-cut]="chip.is_kpi_cut"
                      [matTooltip]="chip.label"
                    >
                      <span class="payroll-adjustment-emoji" aria-hidden="true">{{ chip.emoji }}</span>
                      <span class="payroll-adjustment-values">
                        @if (chip.amount != null) {
                          <span>{{ formatAdjustmentAmount(chip.amount, !chip.is_expected_normal) }}</span>
                        }
                        @if (chip.text) {
                          <span class="payroll-adjustment-meta">({{ chip.text }})</span>
                        }
                      </span>
                    </span>
                  }
                </button>
              } @else {
                <span class="payroll-adjustments-empty">—</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="price_per_hour">
            <th mat-header-cell *matHeaderCellDef>€/h</th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              @if (PER_HOUR_CONTRACTS.includes(formGroup.value.user.working_contracts[0].working_contract_type.slug)) {
                {{ formGroup.value.price_per_hour | currency }}
              } @else {
                -
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="hours_worked_since_last_day_taken_into_account_for_hours">
            <th
              mat-header-cell
              *matHeaderCellDef
              matTooltip="Horas reales desde el día siguiente al último día tenido en cuenta de la nómina anterior"
            >
              Horas acum.
            </th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              @if (formGroup.value.hours_worked_since_last_day_taken_into_account_for_hours != null) {
                {{ formGroup.value.hours_worked_since_last_day_taken_into_account_for_hours | number: '1.0-2' }}h
              } @else {
                -
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="last_day_taken_into_account_for_hours">
            <th mat-header-cell *matHeaderCellDef matTooltip="Último día cuyas horas se han contado al generar esta nómina">
              Último día h.
            </th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              @if (formGroup.value.last_day_taken_into_account_for_hours) {
                {{ formGroup.value.last_day_taken_into_account_for_hours | date: 'dd/MM/yyyy' : 'UTC' }}
              } @else {
                -
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="seniority_bonus">
            <th mat-header-cell *matHeaderCellDef>Seniority</th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              {{ formGroup.value.seniority_bonus | currency }}
            </td>
          </ng-container>

          <ng-container matColumnDef="irpf">
            <th mat-header-cell *matHeaderCellDef>IRPF</th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              {{ formGroup.value.irpf_prcnt / 100 | percent }}
            </td>
          </ng-container>

          <!-- Flexible remuneration -->
          <ng-container matColumnDef="flexible_remuneration">
            <th mat-header-cell *matHeaderCellDef matTooltip="Correspondiente a lo gastado el mes anterior. Máximo 220€.">Ret. flex.</th>
            <td mat-cell *matCellDef="let formGroup">
              <mat-form-field appearance="outline" class="nobottom" style="width: 100px">
                <input min="0" matInput type="number" [formControl]="formGroup.controls['flexible_remuneration']" />
                <span matSuffix>
                  @if (formGroup.value.extract_flexible_remuneration_from_salary) {
                    excl. (€)
                  } @else {
                    incl. (€)
                  }
                </span>
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="extract_flexible_remuneration_from_salary">
            <th mat-header-cell *matHeaderCellDef>Extraer Ret. Flex.</th>
            <td mat-cell *matCellDef="let formGroup; let i = index" style="text-align: center">
              <mat-checkbox [formControl]="formGroup.controls['extract_flexible_remuneration_from_salary']"></mat-checkbox>
            </td>
          </ng-container>

          <!-- KM things -->
          <ng-container matColumnDef="fuel_cost_per_km">
            <th mat-header-cell *matHeaderCellDef matTooltip="Correspondiente al mes anterior">€/km</th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              {{ formGroup.value.fuel_cost_per_km | currency }}
            </td>
          </ng-container>
          <ng-container matColumnDef="distance_in_km">
            <th mat-header-cell *matHeaderCellDef>Distancia en km.</th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              <mat-form-field appearance="outline" class="nobottom" style="width: 100px">
                <input matInput type="number" placeholder="10km..." [formControl]="formGroup.controls['distance_in_km']" />
                <span matSuffix>km.</span>
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="total_fuel_cost">
            <th mat-header-cell *matHeaderCellDef matTooltip="Correspondiente al mes anterior">Kilometraje</th>
            <td mat-cell *matCellDef="let formGroup; let i = index" [matTooltip]="(formGroup.value.fuel_cost_per_km | currency) + '/km'">
              {{ formGroup.value.total_fuel_cost | currency }}
            </td>
          </ng-container>

          <!-- Additional Salary -->
          <ng-container matColumnDef="additional_salary">
            <th mat-header-cell *matHeaderCellDef>Extra</th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              <mat-form-field appearance="outline" class="nobottom" style="width: 100px">
                <input matInput min="0" type="number" [formControl]="formGroup.controls['additional_salary']" />
                <span matSuffix>€</span>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Additional Salary -->
          <ng-container matColumnDef="additional_hours">
            <th mat-header-cell *matHeaderCellDef>Horas extra</th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              <mat-form-field appearance="outline" class="nobottom" style="width: 100px">
                <input matInput min="0" type="number" [formControl]="formGroup.controls['additional_hours']" />
                <span matSuffix>h</span>
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="total_to_pay">
            <th mat-header-cell *matHeaderCellDef matTooltip="Líquido a percibir según el PDF de gestoría (no se calcula en Bisual)">
              A pagar
            </th>
            <td mat-cell *matCellDef="let formGroup">
              @if (formGroup.value.total_to_pay !== null) {
                <strong>{{ formGroup.value.total_to_pay | currency }}</strong>
              } @else {
                <span class="muted">—</span>
              }
            </td>
          </ng-container>

          <!-- Plus 0 -->
          <ng-container matColumnDef="plus_0">
            <th mat-header-cell *matHeaderCellDef>Plus Bisual</th>
            <td mat-cell *matCellDef="let formGroup">
              {{ $safeNavigationMigration(formGroup.controls['plus_0_amount']?.value) | currency }}
              <span class="plus-label">{{ formGroup.controls['plus_0_name']?.value || '-' }}</span>
            </td>
          </ng-container>

          <!-- Plus 1 -->
          <ng-container matColumnDef="plus_1">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let formGroup">
              {{ $safeNavigationMigration(formGroup.controls['plus_1_amount']?.value) | currency }}
              <span class="plus-label">{{ formGroup.controls['plus_1_name']?.value || '-' }}</span>
            </td>
          </ng-container>

          <!-- Plus 2 -->
          <ng-container matColumnDef="plus_2">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let formGroup">
              {{ $safeNavigationMigration(formGroup.controls['plus_2_amount']?.value) | currency }}
              <span class="plus-label">{{ formGroup.controls['plus_2_name']?.value || '-' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="is_send_to_management" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>Gest</th>
            <td mat-cell *matCellDef="let formGroup; let i = index" style="text-align: center">
              <div class="flex flex-row">
                <mat-icon
                  [ngClass]="{
                    'text-green-500': formGroup.value.is_send_to_management,
                    'text-red-500': !formGroup.value.is_send_to_management,
                  }"
                  [matTooltip]="formGroup.value.is_send_to_management ? 'Enviado' : 'No enviado'"
                >
                  {{ formGroup.value.is_send_to_management ? 'check_circle' : 'cancel' }}
                </mat-icon>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="is_send_to_employee" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>Empl</th>
            <td mat-cell *matCellDef="let formGroup; let i = index" style="text-align: center">
              <div class="flex flex-row">
                <mat-icon
                  [ngClass]="{
                    'text-green-500': formGroup.value.is_send_to_employee,
                    'text-red-500': !formGroup.value.is_send_to_employee,
                  }"
                  [matTooltip]="formGroup.value.is_send_to_employee ? 'Enviado' : 'No enviado'"
                >
                  {{ formGroup.value.is_send_to_employee ? 'check_circle' : 'cancel' }}
                </mat-icon>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="is_modified_after_sent_to_employee" stickyEnd>
            <th mat-header-cell *matHeaderCellDef matTooltip="Modificada después de enviar al empleado">Mod</th>
            <td mat-cell *matCellDef="let formGroup; let i = index" style="text-align: center">
              @if (formGroup.value.is_modified_after_sent_to_employee) {
                <div class="flex flex-row">
                  <mat-icon class="text-warning" matTooltip="Esta nómina ha sido modificada después de enviarla al trabajador">
                    warning
                  </mat-icon>
                </div>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="gestoria_holded_status" stickyEnd>
            <th mat-header-cell *matHeaderCellDef matTooltip="Estado importación PDF gestoría → Holded">Hold</th>
            <td mat-cell *matCellDef="let formGroup" style="text-align: center">
              @if (formGroup.value.gestoria_holded_status) {
                <div class="flex flex-row justify-center">
                  <mat-icon
                    [ngClass]="gestoriaHoldedIconClass(formGroup.value.gestoria_holded_status)"
                    [matTooltip]="gestoriaHoldedTooltip(formGroup.value.gestoria_holded_status)"
                  >
                    {{ gestoriaHoldedIcon(formGroup.value.gestoria_holded_status) }}
                  </mat-icon>
                </div>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="row_actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef aria-label="Acciones"></th>
            <td mat-cell *matCellDef="let formGroup; let i = index">
              <div class="flex flex-row items-center justify-end">
                @if (!formGroup.value.payroll_file_path && !formGroup.controls['payroll_file'].value) {
                  <input #payrollPdfInput type="file" accept="application/pdf" hidden (change)="onPayrollPdfFileSelected($event, i)" />
                  <button mat-icon-button type="button" matTooltip="Subir PDF" (click)="payrollPdfInput.click()">
                    <mat-icon>upload</mat-icon>
                  </button>
                } @else if (!formGroup.value.payroll_file_path) {
                  <mat-icon matTooltip="Se subirá una vez guardes los cambios">schedule</mat-icon>
                }
                <button mat-icon-button type="button" [matMenuTriggerFor]="payrollRowMenu" aria-label="Más acciones de la nómina">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #payrollRowMenu="matMenu">
                  <button mat-menu-item type="button" (click)="downloadPdf(i)" [disabled]="!formGroup.value.payroll_file_path">
                    <mat-icon matPrefix>download</mat-icon>
                    Descargar nómina en PDF
                  </button>
                  <button
                    mat-menu-item
                    type="button"
                    (click)="removeFile(i)"
                    [disabled]="!formGroup.value.payroll_file_path && !formGroup.controls['payroll_file'].value"
                  >
                    <mat-icon matPrefix color="warn">delete</mat-icon>
                    Eliminar archivo de nómina
                  </button>
                  <button mat-menu-item type="button" (click)="openPayrollCommentsDialog(i)">
                    <mat-icon matPrefix>comment</mat-icon>
                    Comentarios sobre nómina
                  </button>
                  <button mat-menu-item type="button" (click)="openPayrollJustificationDialog(i)">
                    <mat-icon matPrefix>info</mat-icon>
                    Justificación de nómina
                  </button>
                  <span
                    class="payroll-row-menu-tooltip"
                    matTooltip="No hay viajes con distancia registrada en el mes anterior"
                    [matTooltipDisabled]="formGroup.value.has_mileage_trips"
                  >
                    <button
                      mat-menu-item
                      type="button"
                      (click)="openPayrollMileageDialog(i)"
                      [disabled]="!formGroup.value.has_mileage_trips"
                    >
                      <mat-icon matPrefix>directions_car</mat-icon>
                      Kilometraje
                    </button>
                  </span>
                </mat-menu>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      }
    </div>

    @if (length > 0 && !generatingPayrolls) {
      <div class="container mt-3 mb-0">
        <div class="row">
          <div class="card col-12 col-lg-8 mb-0">
            <mat-form-field class="nobottom w-100" [formGroup]="form" appearance="outline">
              <mat-label>Comentario para la gestoría:</mat-label>
              <textarea
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
                formControlName="general_comment"
              ></textarea>
            </mat-form-field>
          </div>

          <div class="card col-12 col-lg-3 offset-lg-1 mb-0" style="text-align: center">
            <span
              style="font-size: 38px; font-weight: 700; width: 100%; margin: 0 auto"
              matTooltip="Incluye gastos por SS, retribución flexible, combustible y extras."
              >{{ total | currency }}</span
            >
          </div>
        </div>
      </div>
    }
  </div>
</div>
